import {inject, Injectable, Pipe, PipeTransform} from '@angular/core';
import {StateService} from "../../core/services/state.service";

@Pipe({
  name: 'userHasPrivilege',
  standalone: true
})
@Injectable({
  providedIn: 'root'
})
export class UserHasPrivilegePipe implements PipeTransform {
  private stateService = inject(StateService);

  transform(privileges: string | string[]): boolean {
    privileges ??= [];
    if (typeof privileges === 'string') {
      privileges = [privileges];
    }
    return !privileges.length || this.stateService.currentUser$.getValue().Privileges.some(privilege => privileges.includes(privilege.toLowerCase()));
  }
}
